import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as gql from '../gql'
import type * as models from '../models'

const QUERY: ents.core.dms.data.query.Query<models.Unit> = {
  /* eslint-disable sort-keys */
  selection: {
    '{}': {
      code: { '@.': '!code' },
      id: { '@.': '!id' },
      name: { '@.': '!name' },
      parentId: { '@': 'leader' },
    },
  },
  target: 'ent:!personnel:!employee',
  subqueries: {
    leader: {
      selection: { '@>': [{ '@.': '!leader' }, 'recordId'] },
      target: 'ent:!personnel_leaders:!relationship',
      ref: {
        attr: 'attr:ent#!personnel_leaders#!relationship:!personnel',
      },
      quantity: 1,
    },
  },
  /* eslint-enable sort-keys */
}

const isZoneContextDefined = <T, U>(
  data: [T, U],
): data is [T, NonNullable<U>] => !!data[1]

// TODO: Implement
export const onUnitsRequest = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.getUnits.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.filter(isZoneContextDefined),
      rxjs.switchMap(([action, zoneContext]) =>
        gql.queries.units
          .execute({
            ...zoneContext,
            query: JSON.stringify(QUERY),
          })
          .pipe(
            // Handles success
            rxjs.map(units =>
              feature.actions.getUnits.success.from(action).create({
                request: action.data,
                response: units,
              }),
            ),
            // Handles error
            rxjs.catchError(error =>
              rxjs.of(
                feature.actions.getUnits.error.from(action).create({
                  error,
                  request: action.data,
                }),
              ),
            ),
          ),
      ),
    ),
)
